import moment from 'moment';

export const DATE_COLLAR_UPDATED_FORMAT = 'DD-MM-YYYY h:mm A';

export const dateToText = (date: Date | undefined) =>
  date ? moment(date).format(DATE_COLLAR_UPDATED_FORMAT) : ' - ';
